import axios from 'axios';
import { generateSignature } from '@/utils/apiSign';

const http = axios.create({
    baseURL: 'https://c.n.huishouka.com.cn',
    timeout: 15000,
});

http.interceptors.request.use(
    async (config) => {
        // 生成签名信息
        const signatureInfo = await generateSignature();

        // 将签名信息添加到请求头
        config.headers['X-S-Str1'] = signatureInfo.str1;
        config.headers['X-S-Str2'] = signatureInfo.str2;
        config.headers['X-S-Str3'] = signatureInfo.str3;
        config.headers['X-S'] = signatureInfo.sign;
        config.headers['Timestamp'] = signatureInfo.tmp;
        return config;
    },
    (error) => Promise.reject(error)
);

export default http;
